import { render, staticRenderFns } from "./DetailDescription.vue?vue&type=template&id=73128fe1&scoped=true"
import script from "./DetailDescription.vue?vue&type=script&lang=js"
export * from "./DetailDescription.vue?vue&type=script&lang=js"
import style0 from "./DetailDescription.vue?vue&type=style&index=0&id=73128fe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73128fe1",
  null
  
)

export default component.exports